import Image from 'next/image'

import { IconWrapper, LinkButton } from './InstallPrompt'
import StatusBanner from './StatusBanner'
import { useInstallPrompt } from 'hooks/useInstallPrompt'
import { useTracking } from 'hooks/useTracking'
import { EVENT_NAMES } from 'lib/tracking'

function ProductRecommendationsInstallPrompt() {
	const track = useTracking()
	const { tutorial, isVisible } = useInstallPrompt()

	const onLinkClick = () => {
		if (!tutorial) {
			return
		}
		track(EVENT_NAMES.INSTALL_PROMPT_LINK_CLICKED, { link: tutorial.name, sectionName: 'product-recommendations' })
	}

	return (
		<StatusBanner type="warning" isVisible={isVisible} title="Widget not installed">
			{tutorial ? (
				<>
					{`Install the widget on your ${tutorial.name} ${
						tutorial.isEcommerce ? 'store' : 'website'
					} and boost sales with personalized product recommendations`}
					<LinkButton rel="noopener,noreferrer" target="_blank" onClick={onLinkClick} href={tutorial.articleURL}>
						{`Check ${tutorial.name} install guide`}
						<IconWrapper>
							<Image height="16" width="16" src={tutorial.logoDark} alt={tutorial.name} />
						</IconWrapper>
					</LinkButton>
				</>
			) : (
				<>
					Install the widget on your website and boost sales with personalized product recommendations.
					<LinkButton href="/configurator/code-snippet">Install widget</LinkButton>
				</>
			)}
		</StatusBanner>
	)
}

export default ProductRecommendationsInstallPrompt
